import { createTheme, type Theme } from '@mui/material/styles';
import { muiCoreLocales, muiGridLocales, muiPickersLocales } from '../i18n/muiLocales';
import type { Language } from '../i18n/language';
import type { ResolvedColorMode } from './colorMode';

/** Brand colour, taken from the logo. */
const brandBlue = '#0079ff';

/** Neutral near-black surfaces (VS Code-like), not a brand-tinted navy. */
const darkBackground = '#181818';
const darkSurface = '#1f1f1f';

/**
 * The theme carries the language as well as the mode: MUI's own translations arrive as extra
 * arguments to `createTheme`, which is how the data grid's chrome follows the switcher without any
 * component passing `localeText` itself.
 */
export function buildTheme(mode: ResolvedColorMode, language: Language): Theme {
  return createTheme(
    {
      palette: {
        mode,
        primary: { main: brandBlue },
        // Dark mode uses the standard neutral dark greys; the brand shows only through the primary
        // colour. Light mode keeps MUI's defaults.
        ...(mode === 'dark'
          ? {
              background: { default: darkBackground, paper: darkSurface },
            }
          : {}),
      },
      typography: { fontSize: 14 },
      components: {
        MuiAppBar: {
          // A surface-coloured bar rather than a primary-coloured one: the light logo asset carries
          // dark navy text, which needs a light background to read.
          defaultProps: { color: 'default', elevation: 0 },
        },
      },
    },
    muiCoreLocales[language],
    muiGridLocales[language],
    muiPickersLocales[language],
  );
}
